// Cart Recommendations Functions
// This file is always loaded to ensure recommendations work from any page

/**
 * Update dynamic recommendations based on cart data
 * Uses Shopify's recommendations API to fetch relevant products
 */
function updateDynamicRecommendations(cartData = null) {
  // Get the product grid ID specifically from within cart-drawer__you-may-love-recommendations div
  // Scope strictly to cart drawer to avoid affecting similarly named sections elsewhere
  const recommendationsDiv = document.querySelector('cart-drawer .cart-drawer__you-may-love-recommendations');
  if (!recommendationsDiv) {
    return;
  }
  
  const productGrid = recommendationsDiv.querySelector('#you-may-love-product-grid');
  if (!productGrid) {
    return;
  }
  
  // Use provided cart data or get from global cart object
  let cart = cartData;
  
  if (!cart) {
    // Try to get cart from global object or fetch if needed
    if (typeof window.cart !== 'undefined') {
      cart = window.cart;
    } else {
      // Fallback to fetch if no global cart available
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          updateDynamicRecommendations(cartData);
        })
        .catch(error => {
          console.error('❌ Error fetching cart:', error);
          productGrid.innerHTML = '';
        });
      return;
    }
  }
  
  if (!cart || cart.items.length === 0) {
    // Cart is empty, hide recommendations
    productGrid.innerHTML = '';
    return;
  }
  
  // Get the first product ID from cart (same as cart page logic)
  const firstProductId = cart.items[0].product_id;
  
  // Use the same pattern as cart page - fetch recommendations section
  const recommendationsUrl = `${window.Shopify?.routes?.root || '/'}recommendations/products?section_id=cart-recommendations&product_id=${firstProductId}&limit=5`;
  
  fetch(recommendationsUrl)
    .then(response => {
      return response.text();
    })
    .then(text => {
      if (text.length > 0) {
        const html = document.createElement('div');
        html.innerHTML = text;
        
        const recommendations = html.querySelector('product-recommendations');
        
        if (recommendations && recommendations.innerHTML.trim().length) {
          // Extract the product grid from the recommendations
          const newProductGrid = recommendations.querySelector('#cart-recommendations-grid');
          if (newProductGrid) {
            productGrid.innerHTML = newProductGrid.innerHTML;
            
            // Re-initialize any functionality
            setTimeout(() => {
              // Initialize swatch functionality for dynamically loaded recommendations
              initializeRecommendationSwatches();
              
              // Complete Look swatches are handled by complete-look-size-selector.js using event delegation
              // Just ensure the event delegation is properly initialized
              if (typeof window.initializeCompleteLookSwatches === 'function') {
                window.initializeCompleteLookSwatches();
              }
              
              // Initialize cart swatches if available
              if (typeof initializeCartSwatches === 'function') {
                initializeCartSwatches();
              }
              
              // Initialize drag functionality if available
              if (typeof initializeCartRecommendationsDrag === 'function') {
                initializeCartRecommendationsDrag();
              }
            }, 100);
          } else {
            productGrid.innerHTML = '';
          }
        } else {
          productGrid.innerHTML = '';
        }
      } else {
        productGrid.innerHTML = '';
      }
    })
    .catch(error => {
      console.error('❌ Error fetching recommendations:', error);
      productGrid.innerHTML = '';
    });
    setTimeout(initCartDrawerSwiper, 500);
}

/**
 * Initialize swatch functionality for recommendation products
 */
function initializeRecommendationSwatches() {
  // Find all variant swatches in the recommendations section
  const recommendationSwatches = document.querySelectorAll('.cart-drawer__you-may-love-recommendations .variant-swatch');
  
  recommendationSwatches.forEach(function (swatch) {
    // Remove existing event listeners to prevent duplicates
    swatch.removeEventListener('click', handleRecommendationSwatchClick);
    
    // Add click event listener
    swatch.addEventListener('click', handleRecommendationSwatchClick);
  });
}

// Complete Look swatches are handled by complete-look-size-selector.js using event delegation
// No need to duplicate the functionality here

/**
 * Handle swatch clicks in recommendation products
 */
function handleRecommendationSwatchClick(event) {
  const swatch = event.target.closest('.variant-swatch');
  if (!swatch) return;

  // Set active class on the clicked swatch
  const siblings = swatch.parentElement.children;
  for (let sibling of siblings) {
    if (sibling !== swatch) {
      sibling.classList.remove('active');
    }
  }
  swatch.classList.add('active');

  // Update product image and price
  const swatchElement = swatch.querySelector('.swatch');
  if (swatchElement) {
    const dataSrc = swatchElement.getAttribute('data-src');
    const dataUrl = swatchElement.getAttribute('data-url');
    const dataPrice = swatchElement.getAttribute('data-price');
    const dataSalePrice = swatchElement.getAttribute('data-sale-price');

    if (dataSrc && dataUrl) {
      // Find the product card
      const card = swatch.closest('.card-wrapper, .card');
      if (card) {
        // Update product image
        const productImage = card.querySelector('img');
        if (productImage) {
          productImage.src = dataSrc;
        }
        
        // Update product link
        const productLink = card.querySelector('a');
        if (productLink) {
          productLink.href = dataUrl;
        }
        
        // Update price
        if (dataPrice) {
          const priceContainer = card.querySelector('.price__container');
          if (priceContainer) {
            let priceHTML = '';
            if (dataSalePrice) {
              priceHTML = `
                <div class="price__sale">
                  <span>
                    <s class="price-item price-item--regular">${dataSalePrice}</s>
                  </span>
                  <span class="price-item price-item--sale price-item--last">
                    ${dataPrice}
                  </span>
                </div>
              `;
            } else {
              priceHTML = `
                <div class="price__regular">
                  <span class="price-item price-item--regular">
                    ${dataPrice}
                  </span>
                </div>
              `;
            }
            priceContainer.innerHTML = priceHTML;
          }
        }
      }
    }
  }
}

// Make functions globally available
window.updateDynamicRecommendations = updateDynamicRecommendations;
window.initializeRecommendationSwatches = initializeRecommendationSwatches;

// Set up event listeners

document.addEventListener('cartRecommendationsUpdated', (event) => {
  // Extract cart data from event detail if available
  const cartData = event.detail || null;
  updateDynamicRecommendations(cartData);
});

// Also listen for cart:updated event
document.addEventListener('cart:updated', () => {
  setTimeout(() => {
    updateDynamicRecommendations();
  }, 50);
});


